import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT } from "../../../../services/index";
import { message } from "antd";

export const useFetchCompany = () => {
  return useQuery(
    ["getFetchCompany"],
    async (value) => {
      try {
        const endpoint = `/api/v1/companies/list`;
        const { result } = await GET(endpoint);
        //const { result } = tableBank
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Company..");
      }
    }
  );
};

export const useFetchCompanyForNavbar = () => {
  return useQuery(
    ["getFetchCompanyForNavbar"],
    async () => {
      try {
        const endpoint = `/api/v1/companies/list`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Company..");
      }
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // เดิม staleTime/cacheTime = Infinity + refetchOnMount false → แก้สีบริษัทแล้ว
      // ไม่มีวันเห็นจนกว่าจะ login ใหม่ · 5 นาทีก็พอ (ตอบแค่ไม่กี่แถว ไม่กระทบโหลด)
      refetchOnMount: true,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    }
  );
};



export const UseFetchCreateCompany = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/companies`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Company..");
    }
  });
};

export const UseFetchUpdateCompany = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/companies`;
      const result = PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Update Company..");
    }
  });
};

// อัปโลโก้บริษัท — คืน URL มาให้เก็บใน form แล้วค่อยกดบันทึกทีเดียว
export const useUploadCompanyLogo = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/companies/logo`, payload),
  });
};

// คัดลอกการตั้งค่าจากบริษัทอื่นเข้าบริษัท targetId (backoffice เท่านั้น)
// dryRun: true = ขอแค่ตัวเลขว่าจะเพิ่ม/ข้ามเท่าไร ยังไม่เขียนอะไร
export const useCopyCompanySettings = () => {
  return useMutation({
    mutationFn: async ({ targetId, ...payload }) =>
      await POST(`/api/v1/companies/${targetId}/copy-settings`, payload),
  });
};
